import { createFileRoute, retainSearchParams } from '@tanstack/react-router';

// Carries the results filters (validated on the results index) through the booking
// steps, so going back to the results (Stepper) restores the transports the search was
// started with instead of falling back to every type, which turned a rental-only
// "replacement vehicle" search into a multimodal podium.
// No validateSearch here: its `.catch` defaults would override the retained values.
export const Route = createFileRoute('/$missionId/search-results/$searchId')({
	search: {
		middlewares: [retainSearchParams(true)],
	},
});
